module.exports = __webpack_public_path__ + "static/media/referfriend.6a466ee7.png";